import React from "react";
import { AlertCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Problem() {
  const { t } = useLang();
  return (
    <section className="section-y bg-white" data-testid="problem-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="overline">{t.problem.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.problem.title}
          </h2>
        </div>
        <div className="lg:col-span-7">
          <p className="text-lg text-brand-graphite leading-relaxed text-pretty">
            {t.problem.body}
          </p>
          <ul className="mt-10 grid sm:grid-cols-1 gap-4">
            {t.problem.points.map((p, i) => (
              <li
                key={i}
                className="card-soft card-soft-hover p-5 md:p-6 flex items-start gap-4"
                data-testid={`problem-point-${i}`}
              >
                <span className="mt-0.5 grid place-items-center h-8 w-8 rounded-full bg-brand-ink text-white shrink-0">
                  <AlertCircle className="h-4 w-4" />
                </span>
                <p className="text-brand-graphite">{p}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
